export default {
  calcRelated: (relatedA, relatedB) => {
    let xSum = 0
    let ySum = 0
    let xySum = 0
    let xxSum = 0
    let yySum = 0

    relatedA.forEach((data, index) => {
      let xVal = data.value
      let yVal = relatedB[index].value

      xSum += xVal
      ySum += yVal
      xySum += xVal * yVal
      xxSum += xVal * xVal
      yySum += yVal * yVal
    })

    let length = relatedA.length
    let xAvg = xSum / length
    let yAvg = ySum / length
    let a = (xySum - xSum * yAvg) / (xxSum - xSum * xAvg)
    let b = yAvg - a * xAvg

    return {
      a,
      b,
      r: (xySum - xSum * ySum / length) / Math.sqrt((xxSum - xSum * xSum / length) * (yySum - ySum * ySum / length))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Data/calc.js